// extracted by mini-css-extract-plugin
export var boldText = "_8h-4";
export var checkboxContainer = "_8h-6";
export var closeIcon = "_8h-i";
export var container = "_8h-0";
export var drawer = "_8h-8";
export var drawerContent = "_8h-9";
export var extraSmallText = "_8h-5";
export var fulfillmentGroupTable = "_8h-e";
export var largeText = "_8h-3";
export var loadingSpinnerContainer = "_8h-j";
export var mediumText = "_8h-2";
export var narrow = "_8h-f";
export var notificationLink = "_8h-l";
export var packageCheckIconContainer = "_8h-7";
export var slideoutHeaderActions = "_8h-g";
export var slideoutHeaderActionsShifted = "_8h-h";
export var slideoutHeaderContainer = "_8h-a";
export var slideoutModal = "_8h-c";
export var stickyHeaderWrapper = "_8h-b";
export var table = "_8h-k";
export var tableContainer = "_8h-d";
export var tertiaryText = "_8h-1";